import React from 'react';
import classNames from 'classnames';
import { TooltipPortalProvider } from '../../context/tooltip-context';
import AppWrapper from '../app-wrapper';
import { type AppProps } from './app-props';
import styles from './app.scss';

type PropsMobile = {
  mobileHeader?: React.FunctionComponentElement<{ menu?: React.FunctionComponentElement<any> }>;
};

const AppMobile: React.FC<AppProps & PropsMobile> = ({
  main,
  messageRoot,
  mobileHeader,
  modalRoot,
  popoverRoot,
}) => (
  <AppWrapper className={classNames(styles.app, 'app-mobile', 'blog-background-color')}>
    <TooltipPortalProvider>
      {messageRoot}
      {modalRoot}
      {popoverRoot}
      <div id="content-wrapper">
        {mobileHeader}
        {main}
      </div>
    </TooltipPortalProvider>
  </AppWrapper>
);

export default AppMobile;
